import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectFilterValues = (store: StoreSchema) => store.instances.filter

export const selectIp = (store: StoreSchema) => store.instances.filter.ip
export const selectLabel = (store: StoreSchema) => store.instances.filter.label
export const selectInstanceName = (store: StoreSchema) => store.instances.filter.instanceName
export const selectProductVersion = (store: StoreSchema) => store.instances.filter.productVersion
